/**
 * TransitionCatalog Enhanced Component
 * Unique Properties: Template library, guard builder, action registry, usage stats
 */

import { Badge, Card, Code, Container, Grid, Group, Paper, Stack, Tabs, Text, Title } from '@mantine/core';
import '@mantine/core/styles.css';
import { IconBook, IconCode, IconGitBranch } from '@tabler/icons-react';
import React, { useEffect, useRef, useState } from 'react';
import { TabulatorFull } from 'tabulator-tables';
import 'tabulator-tables/dist/css/tabulator_midnight.min.css';
import WorkflowSearchMenu from './WorkflowSearchMenu';

interface TransitionCatalogProps {
    data?: any;
    mode?: 'browse' | 'edit' | 'stats';
}

export const TransitionCatalogEnhanced: React.FC<TransitionCatalogProps> = ({ data = {}, mode = 'browse' }) => {
    const [activeTab, setActiveTab] = useState('catalog');
    const tableRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (tableRef.current) {
            new TabulatorFull(tableRef.current, {
                data: [],
                layout: 'fitColumns',
                columns: [
                    { title: 'Transition', field: 'name', headerFilter: true },
                    { title: 'Type', field: 'type' },
                    { title: 'Guards', field: 'guards' },
                    { title: 'Actions', field: 'actions' },
                    { title: 'Usage', field: 'usage', formatter: (cell: any) => `${cell.getValue()} times` }
                ]
            });
        }
    }, []);

    return (
        <Container size="xl">
            <Paper shadow="sm" p="lg">
                <Title order={2} mb="lg">Transition Catalog</Title>
                <Tabs value={activeTab} onChange={(v) => setActiveTab(v ?? '')}>
                    <Tabs.List>
                        <Tabs.Tab value="catalog" leftSection={<IconBook size={16} />}>Catalog</Tabs.Tab>
                        <Tabs.Tab value="guards" leftSection={<IconCode size={16} />}>Guards</Tabs.Tab>
                        <Tabs.Tab value="actions" leftSection={<IconGitBranch size={16} />}>Actions</Tabs.Tab>
                    </Tabs.List>
                    <Tabs.Panel value="catalog">
                        <Stack mt="md">
                            <div ref={tableRef} />
                            <Grid>
                                <Grid.Col span={4}>
                                    <Card withBorder>
                                        <Text fw={500} mb="xs">Approval Transition</Text>
                                        <Code block style={{ fontSize: 11 }}>
{`from: "pending"
to: "approved"
guard: "hasApprovalRights"
action: "notifyApproved"`}
                                        </Code>
                                        <Group gap="xs" mt="xs">
                                            <Badge size="sm">Used 145 times</Badge>
                                            <Badge size="sm" color="green">Active</Badge>
                                        </Group>
                                    </Card>
                                </Grid.Col>
                            </Grid>
                        </Stack>
                    </Tabs.Panel>
                </Tabs>
            </Paper>
        </Container>
    );
};

export default TransitionCatalogEnhanced;
